import { useModal, useRouter } from '@application/utils';
import { ApplicationExistsModal } from '@presentation/components';
import type { Dispatch, FC, SetStateAction } from 'react';
import { useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

const init: ReturnType<typeof useApplicationExistsModalSingleton> = {
  breederId: undefined,
  modalHook: {
    show: () => undefined,
    showFromClick: () => undefined,
    close: () => undefined,
    modal: {
      onCloseClick: undefined,
      open: false,
      position: [0, 0],
    },
  },
};

let globalBreederId: Dispatch<SetStateAction<number | undefined>>;

export const useApplicationExistsModalSingleton = () => {
  const modalHook = useModal({});
  const [breederId, setBreederId] = useState<number>();
  globalBreederId = setBreederId;

  return {
    modalHook,
    breederId,
  };
};

export const setBreederId = (breederId: number) => globalBreederId(breederId);

export const useApplicationExistsModal = singletonHook(init, useApplicationExistsModalSingleton);

export const ApplicationExistsModalController: FC = () => {
  const { modalHook, breederId } = useApplicationExistsModal();
  const { navigateToRoute } = useRouter();

  return (
    <ApplicationExistsModal
      modal={modalHook?.modal}
      onCancelClick={() => {
        navigateToRoute('mtApplications');
        modalHook?.close();
      }}
      onContinueClick={() => {
        if (!breederId) return;

        navigateToRoute('application', {
          params: [breederId.toString()],
        });
        modalHook?.close();
      }}
    />
  );
};
